import { useState, useEffect, useContext, useMemo } from "react";
import Select from "react-select";
import { useProviders } from "../hooks/useProviders";
import { translate } from "../utils/Common";
import { getReactSelectStyles } from "../utils/reactSelectThemeStyles";
import ThemeContext from "../contexts/theme";
import Spinner from "./Spinner";
import { FaBuilding } from "react-icons/fa";
import { SelectShell } from "@/components/ui/select-shell";

const ProviderList = ({
  register,
  errors,
  nameShow,
  idShow,
  readOnly,
  setValue,
  valueId,
  setProveedor,
  idHide,
  selectedOption 
}) => {
  const themeContext = useContext(ThemeContext);
  const theme = themeContext?.theme || "light";
  const selectStyles = useMemo(() => getReactSelectStyles(theme, { hasIcon: true }), [theme]);

  const [providersList, setProvidersList] = useState([]);
  // Starts true: between the first render and the effect firing, a false
  // flag with an empty list paints the "nothing here" state for a frame,
  // which reads as the screen finding nothing and then changing its mind.
  const [isLoading, setIsLoading] = useState(true);
  const { getProviders } = useProviders();
  

  useEffect(() => {
    const fetchProviders = async () => {
      setIsLoading(true);
      try {
        const abortController = new AbortController();
        const providers = await getProviders(idShow, abortController.signal, idHide);
        setProvidersList(providers);
      } catch (error) {
        console.error("Error fetching providers", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProviders();
  }, [idShow, getProviders, idHide]);

  const options = providersList.map(prov => ({
    value: prov.IdUsuario,
    label: `${prov.NombreEmpresa}`,
    isDisabled: prov.IdUsuario === idShow,
    typeUser: prov.IdTipoUsuario,
    ...prov
  }));

  const handleProviderSelection = (selectedOption) => {
    setValue(valueId, selectedOption ? selectedOption.value : "");
    if (setProveedor) setProveedor(selectedOption);
  };    

  return (
    <SelectShell icon={<FaBuilding size={16} />} error={errors?.[valueId]}>
        <Select
          isSearchable
          isLoading={isLoading}
          options={options}
          onChange={handleProviderSelection}
          placeholder={nameShow || translate("global.select")}
          value={selectedOption}
          isDisabled={readOnly}
          ref={register}
          name={valueId}
          isClearable
          styles={selectStyles}
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        />
    </SelectShell>
  );
};

export default ProviderList;
